import { render, staticRenderFns } from "./GraduationHatIcon.vue?vue&type=template&id=01fdc958&scoped=true&"
import script from "./GraduationHatIcon.vue?vue&type=script&lang=ts&"
export * from "./GraduationHatIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdc958",
  null
  
)

export default component.exports